/* Silk Theme — Animations (vanilla JS)
   IntersectionObserver scroll reveal + page loading bar.
   Zero external dependencies. Progressive enhancement.
   Each feature is in its own IIFE — one failing doesn't break others. */

// IIFE 1: Progressive enhancement flag
// Adds .js-loaded to <html> so CSS can scope animations that require JS.
// This is also set inline in <head> to prevent flicker — this is the
// fallback for when that inline script isn't present.
(function() {
    'use strict';
    document.documentElement.classList.add('js-loaded');
})();

// IIFE 2: Scroll reveal via IntersectionObserver
// Elements with [data-reveal] fade-up when they enter the viewport.
// Observer disconnects after all elements are revealed (no re-trigger).
(function() {
    'use strict';

    if (!('IntersectionObserver' in window)) {
        // Graceful degradation: reveal everything immediately
        var els = document.querySelectorAll('[data-reveal]');
        for (var i = 0; i < els.length; i++) {
            els[i].classList.add('revealed');
        }
        return;
    }

    var revealElements = document.querySelectorAll('[data-reveal]');
    if (!revealElements.length) return;

    var revealedCount = 0;

    var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
                entries[i].target.classList.add('revealed');
                observer.unobserve(entries[i].target);
                revealedCount++;
            }
        }

        // All elements revealed — clean up observer entirely
        if (revealedCount >= revealElements.length) {
            observer.disconnect();
        }
    }, {
        threshold: 0.1
    });

    for (var i = 0; i < revealElements.length; i++) {
        observer.observe(revealElements[i]);
    }
})();

// IIFE 3: Page loading bar
// Shows a thin gold bar at the top of each new page load, then fades out.
// Uses the CSS loader-progress animation (0→100% width, 300ms) then
// transitions to 'done' state (opacity fade). This runs on every page
// load, providing visual feedback that content is arriving.
(function() {
    'use strict';

    var loader = document.getElementById('page-loader');
    if (!loader) return;

    // Start the loading bar animation
    loader.className = 'loading';
    loader.style.width = '0';

    // After the progress animation completes (300ms), fade out
    setTimeout(function() {
        loader.className = 'done';
        loader.style.width = '100%';
    }, 300);

    // After fade-out transition completes, reset fully
    setTimeout(function() {
        loader.className = '';
        loader.style.width = '0';
    }, 600);
})();
